import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { Document } from '../models/document';
import { MatTableDataSource } from '@angular/material/table';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  public documentDataSource: MatTableDataSource<any>;

  constructor(private db: AngularFirestore,
    private fs: AngularFireStorage) { }

    /*
  selectSent() {
    return this.db.collection<PendingDoc>('sbccv_pendingdocs', ref => ref
      .where('sent', '==', true)
      .where('pending', '==', false)
      .orderBy('date', 'asc')).snapshotChanges();
  }
*/

select() {
  return this.db.collection<Document>('sbccv_documents', ref => ref
    .orderBy('date', 'asc')).snapshotChanges()
}
selectAllDocs() {
  return this.db.collection<Document>('sbccv_documents', ref => ref
    .orderBy('member_name', 'asc')
    .orderBy('date', 'desc')).snapshotChanges()
}
  getDocumentsByMember(member_id, folders) {
    return this.db.collection<Document>('sbccv_documents', ref => ref
      .where('member_id', '==', member_id)
      .orderBy('date', 'asc')).snapshotChanges()
      .subscribe((result) => {

        let array: Document[] = [];

        result.forEach((item) => {
          let doc = new Document();

          doc.id = item.payload.doc.id;
          doc.approved = item.payload.doc.data().approved;
          doc.proofOfVaccine = item.payload.doc.data().proofOfVaccine ? true : false;
          let dt: any = item.payload.doc.data().date;
          doc.date = new Date(dt.seconds * 1000);
          doc.filename = item.payload.doc.data().filename;
          doc.member_id = item.payload.doc.data().member_id
          doc.member_name = item.payload.doc.data().member_name
          doc.url = item.payload.doc.data().url

          doc.folder_id = item.payload.doc.data().folder_id

          const folder = folders.find((e)=>{
            return e.id == doc.folder_id
          })
          
          if(folder){
            doc.folder_name = folder.name
          } else {
            doc.folder_id = 'sETMnBqEPJB6ky0paoF4'
            doc.folder_name = '*'
          }
       

          array.push(doc)
        })

        this.documentDataSource = new MatTableDataSource(array)

      })
  }

  updateApproveDocument(id: string, approved: boolean, folder_id: string) {
    const entity = { 
      'approved': approved, 
      'proofOfVaccine': false,
      'folder_id': folder_id,
      'folder_name': ''
     }
    return this.db.collection('sbccv_documents').doc(id).set(
      entity, { 'merge': true});
  }

  updateDocument(entity: Document) {
    return this.db.collection('sbccv_documents').doc(entity.id).set(Object.assign({}, entity), {'merge': true });
  }

  moveDocument(entity: any) {
    return this.db.collection('sbccv_documents').doc(entity.id).set({'folder_id': entity.folder_id }, {'merge': true });
  }

  addDocument(entity: Document) {
    return this.db.collection('sbccv_documents').add(Object.assign({}, entity));
  }

  delete(doc_id: any) {
    return this.db.collection('sbccv_documents').doc(doc_id).delete()
  }





}


